function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0-claimbot{fill:none;stroke-width:30.0121;stroke-miterlimit:10;}\r\n\t.st1-claimbot{fill:none;stroke-width:22.6483;stroke-miterlimit:10;}\r\n\t.st2-claimbot{fill:none;stroke-width:19;stroke-miterlimit:10;}\r\n\t.st3-claimbot{fill:none;stroke-width:9.5;stroke-miterlimit:10;}\r\n\t.st4-claimbot{fill:none;stroke-width:9.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5-claimbot{fill:none;stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "DETECTAR_x5F_v02"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0-claimbot",
  d: "M402.45,459.37H98.3c-9.17,0-16.6-7.43-16.6-16.6v-30.98c0-59.32,48.09-107.42,107.42-107.42h122.52 c59.32,0,107.42,48.09,107.42,107.42v30.98C419.05,451.93,411.62,459.37,402.45,459.37z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1-claimbot",
  d: "M345.61,295.82H155.13c-13.82,0-25.02-11.2-25.02-25.02v-143.7c0-13.82,11.2-25.02,25.02-25.02h190.48 c13.82,0,25.02,11.2,25.02,25.02v143.7C370.64,284.62,359.43,295.82,345.61,295.82z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2-claimbot",
  d: "M129.25,236.68c-24.72,0-44.76-20.04-44.76-44.76s20.04-44.76,44.76-44.76"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2-claimbot",
  d: "M370.64,236.68c24.72,0,44.76-20.04,44.76-44.76s-20.04-44.76-44.76-44.76"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st3-claimbot",
  cx: 250.37,
  cy: 70.71,
  r: 24.89
}), /*#__PURE__*/React.createElement("path", {
  className: "st3-claimbot",
  d: "M325.79,269.63H172.11c-6.46,0-11.69-5.23-11.69-11.69v-22.51c0-6.46,5.23-11.69,11.69-11.69h153.68 c6.46,0,11.69,5.23,11.69,11.69v22.51C337.48,264.4,332.24,269.63,325.79,269.63z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4-claimbot",
  d: "M160.42,147.16c0,0,5.63-11.73,28.36-11.73s28.36,11.73,28.36,11.73"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4-claimbot",
  d: "M337.94,147.16c0,0-5.63-11.73-28.36-11.73s-28.36,11.73-28.36,11.73"
}), /*#__PURE__*/React.createElement("line", {
  className: "st4-claimbot",
  x1: 248.95,
  y1: 223.74,
  x2: 248.95,
  y2: 269.63
}), /*#__PURE__*/React.createElement("line", {
  className: "st4-claimbot",
  x1: 204.29,
  y1: 223.74,
  x2: 204.29,
  y2: 269.63
}), /*#__PURE__*/React.createElement("line", {
  className: "st4-claimbot",
  x1: 292.48,
  y1: 223.74,
  x2: 292.48,
  y2: 269.63
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.2,151.45c-5.82,0-11.17,2-15.41,5.35c1.28-0.54,2.68-0.83,4.15-0.83c5.92,0,10.72,4.8,10.72,10.72 s-4.8,10.72-10.72,10.72s-10.72-4.8-10.72-10.72c0-0.91,0.13-1.79,0.34-2.64c-2.06,3.63-3.25,7.82-3.25,12.29 c0,13.75,11.14,24.89,24.89,24.89c13.75,0,24.89-11.14,24.89-24.89S203.95,151.45,190.2,151.45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.25,151.45c-5.82,0-11.17,2-15.41,5.35c1.28-0.54,2.68-0.83,4.15-0.83c5.92,0,10.72,4.8,10.72,10.72 s-4.8,10.72-10.72,10.72c-5.92,0-10.72-4.8-10.72-10.72c0-0.91,0.13-1.79,0.34-2.64c-2.06,3.63-3.25,7.82-3.25,12.29 c0,13.75,11.14,24.89,24.89,24.89c13.75,0,24.89-11.14,24.89-24.89S323,151.45,309.25,151.45z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5-claimbot",
  d: "M90.24,242.55c-18.97,0-34.34-22.67-34.34-50.63s15.38-50.63,34.34-50.63"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5-claimbot",
  d: "M67.94,254.48c-18.97,0-34.34-28.01-34.34-62.56s15.38-62.56,34.34-62.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5-claimbot",
  d: "M46.74,266.31c-18.97,0-34.34-33.3-34.34-74.39s15.38-74.39,34.34-74.39"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5-claimbot",
  d: "M405.67,242.55c18.97,0,34.34-22.67,34.34-50.63s-15.38-50.63-34.34-50.63"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5-claimbot",
  d: "M427.97,254.48c18.97,0,34.34-28.01,34.34-62.56s-15.38-62.56-34.34-62.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5-claimbot",
  d: "M449.16,266.31c18.97,0,34.34-33.3,34.34-74.39s-15.38-74.39-34.34-74.39"
}));

var SvgClaimbot = function SvgClaimbot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClaimbot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/claimbot.101974df.svg";
export { ForwardRef as ReactComponent };